import { render, staticRenderFns } from "./change-agent.vue?vue&type=template&id=044b0056&scoped=true"
import script from "./change-agent.vue?vue&type=script&lang=js"
export * from "./change-agent.vue?vue&type=script&lang=js"
import style0 from "./change-agent.vue?vue&type=style&index=0&id=044b0056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044b0056",
  null
  
)

export default component.exports